// messages.js
const companySymbolCurrency = localStorage.getItem("companySymbolCurrency");

export const companyCurrencyNote = `*Note : All figures indicated are in the company currency (  ${companySymbolCurrency} )`;
export const welcomeMessage = "Welcome to my app!";
export const errorMessage = "Something went wrong. Please try again.";
export const notes = [
  { title: "Note 1", content: "This is the content of note 1." },
  { title: "Note 2", content: "This is the content of note 2." },
  { title: "Note 3", content: "This is the content of note 3." },
];
